import { linkBasedModule as modules } from "../infrastructure/react/containers/SideBarContainer";
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

async function accessCheckPromise() {
  const path = window.location.pathname;
  // Support dynamic/child routes like `/sales-order/:id` by matching on prefix.
  const mod =
    modules.find((ele) => ele?.src === path) ||
    modules.find((ele) => {
      const src = ele?.src;
      if (!src) return false;
      return path === src || path.startsWith(`${src}/`);
    });

  // If we can't resolve the module from the current URL, treat as no-access
  // instead of throwing (which would force a logout on deep links).
  if (!mod?.tab) {
    return false;
  }

  const currentModule = mod.tab;
  const token = window.localStorage.getItem("token");
  let response = await fetch(
    `${apiBaseUrl}/inventoryManagement/checkPermission?module=${currentModule}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        authorization: `Token ${token}`,
      },
    }
  );
  let responseJson = await response.json().catch(() => ({}));
  return Boolean(responseJson?.hasAccess);
}

export default accessCheckPromise;
